import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
// import TablesTemplate from './table_template';
import { ADD_ROW,
   DROPDOWN_LIST_NONE, AddItemToDropdown, UPDATE_ROW, DELETE_ROW, 
   JSON_KEY_INDEX, 
   JSON_KEY_INSTRUMENT,
   TABLE_HEADER_INSTRUMENT,
   TABLE_HEADER_INDEX,
   ADD_INDEX,
   TABLE_HEADER_FACTOR,
   JSON_KEY_FACTOR,
   JSON_KEY_ISSUE_QTY,
   TABLE_HEADER_ISSUE_QTY,
   FormatWithDecimals,
   TABLE_HEADER_STATUS,
   JSON_KEY_STATUS,
   ConvertStatus} 
from '../../common/common';
import { useSelector } from 'react-redux';
import { selectIsMarketController, selectTSUserId } from '../../redux/globalsSlice';
import { Modal } from 'react-bootstrap';
import { selectInstruments } from '../../redux/dropDownSlice';
import IndexMembersAdminForm from '../forms/index_members_admin';
import VirtualizedTablesTemplate from './VirtualizedTablesTemplate';
import { instrumentCodeColor, statusTextColor, rowOpacityForStatus } from '../../common/common';

export const FACTOR_DECIMALS = 2;

const IndexMembers = () => {
   // const dispatch = useDispatch();
   const tsUserId = useSelector(selectTSUserId);
   const [showForm, setShowForm] = useState(false);
   const [selectedRow, setSelectedRow] = useState(null);
   const tsUserIdRef = useRef(tsUserId);
   const isMarketController = useSelector(selectIsMarketController);
   const isMarketControllerRef = useRef(isMarketController);
   const [dropDownIndicesData, setDropDownIndicesData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);
   // const [dropDownIndexMembersData, setDropDownIndexMembersData] = useState([{ id: DROPDOWN_LIST_NONE, name: DROPDOWN_LIST_NONE }]);
   const dropDownInstrumentsData = useSelector(selectInstruments);

   useEffect(() => {
      tsUserIdRef.current = tsUserId;
   }, [tsUserId]);

   useEffect(() => {
      isMarketControllerRef.current = isMarketController;
   }, [isMarketController]);
   
   const handleCloseForm = () => {
      setShowForm(false); 
      setSelectedRow(null);
   };

   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[IndexMembersTable] Row Clicked:`, rowData);
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[IndexMembersTable] Row Double Clicked:`, rowData);
      if (isMarketControllerRef.current) {
         setSelectedRow(rowData);
         setShowForm(true);          
      }
   }, []);

   const handleEvents = useCallback((details, setLocalTableData) => {
      // console.log('results details: ', details.data, 'r_type:', details.data.r_type, ', Message:', details.data.message, ', message:', JSON.stringify(details.data.message));

      const modifiedRow = {
         ...details.data,
         id: details.data.idx + details.data.instr,
         issue: FormatWithDecimals(details.data.issue, 0),
         status: ConvertStatus(details.data.status), 
         factor: FormatWithDecimals(details.data.factor, FACTOR_DECIMALS),
      };

      switch (details.type) {
         case ADD_ROW:
            setLocalTableData(prev => {
               const exists = prev.some(row => row.id === modifiedRow.id);
               if (exists) {
                  console.log(`Duplicate message with id ${modifiedRow.id} ignored.`);
                  return prev;
               }
               return [...prev, modifiedRow];
            });

            // dispatch(addMarket({ id: modifiedRow.code, name: modifiedRow.code })); // Add for drop down lists
            // AddItemToDropdown(setDropDownIndexMembersData, { id: details.data.code, name: details.data.code });
            break;

         case UPDATE_ROW:
            console.log('index member update: ', details);
            setLocalTableData(prevData => prevData.map(row => row.id === modifiedRow.id ? modifiedRow : row));
            break;

         case DELETE_ROW:
            setLocalTableData(prevData => prevData.filter(row => row.id !== modifiedRow.id));
            break;

         case ADD_INDEX:
            AddItemToDropdown(setDropDownIndicesData, { id: details.data.idx, name: details.data.idx });
            break;

         default:
            console.log('Unknown event type:', details.type);
            break;
      }
   }, []);

   const columnStyling = useMemo(() => {
      const base = {};
      base[JSON_KEY_INDEX] = (rowData) => ({
         color: instrumentCodeColor(rowData.status),
      });
      base[JSON_KEY_STATUS] = (rowData) => ({
         color: statusTextColor(rowData.status),
      });
      return base;
   }, []);
   
   const columns = useMemo(() => [
      // { Header: TABLE_HEADER_ID, accessor: JSON_KEY_ID }, // don't show it but it is still there
      // { Header: TABLE_HEADER_ID, accessor: JSON_KEY_ID },
      { Header: TABLE_HEADER_INDEX, accessor: JSON_KEY_INDEX },
      { Header: TABLE_HEADER_INSTRUMENT, accessor: JSON_KEY_INSTRUMENT },
      // { Header: TABLE_HEADER_PRICE_DECIMALS, accessor: JSON_KEY_PRICE_DECIMALS },
      { Header: TABLE_HEADER_FACTOR, accessor: JSON_KEY_FACTOR },
      { Header: TABLE_HEADER_ISSUE_QTY, accessor: JSON_KEY_ISSUE_QTY },
      { Header: TABLE_HEADER_STATUS, accessor: JSON_KEY_STATUS },
   ], []);

   return (
      <>
         <VirtualizedTablesTemplate
            columns={columns}
            eventHandlers={handleEvents}
            tableName="IndexMembersTable"
            onRowClick={handleSingleClick}
            onRowDoubleClick={handleDoubleClick}
            highlightOnClick={true}
            enableSearch={true}
            columnStyling={columnStyling}
            rowStyling={(row) => ({ opacity: rowOpacityForStatus(row.status) })}
         />
            
         <Modal show={showForm} onHide={handleCloseForm}>
            <IndexMembersAdminForm rowData={selectedRow} onClose={handleCloseForm} instrumentCodeOptions={dropDownInstrumentsData} indicesOptions={dropDownIndicesData} />
         </Modal>
      </>
   );
};

export default IndexMembers;
